// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"741":"0c2996c6","787":"b2235c27"}[chunkId] + ".chunk.js";
};